import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAnalyticsUtilities } from "@air/analytics";
import { FlashFilledIcon } from "@air/next-icons";
import { Popover } from "@air/primitive-popover";
import { useAirModal } from "@air/provider-modal";
import { memo, useCallback, useState } from "react";
import { PlansModal } from "~/components/Modals/PlansModal/PlansModal";
import { UPSELL_FLASH_ICON_BUTTON } from "~/constants/testIDs";
import { useSubscriptionContext } from "~/providers/SubscriptionProvider";
export const UpsellFlashIconButton = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [showPlansModal] = useAirModal(PlansModal);
    const [isOpen, setIsOpen] = useState(false);
    const { track } = useAnalyticsUtilities();
    const { data: subscription } = useSubscriptionContext();
    const handleUpgradeClick = useCallback(()=>{
        // Track upgrade button clicked with current plan
        track("Upgrade Button Clicked", {
            plan: (subscription === null || subscription === void 0 ? void 0 : subscription.plan) || "unknown"
        });
        showPlansModal();
    }, [
        track,
        subscription === null || subscription === void 0 ? void 0 : subscription.plan,
        showPlansModal
    ]);
    return /*#__PURE__*/ _jsx(Popover, {
        side: "top",
        align: "start",
        "data-theme": "dark",
        className: "max-w-80 border-0",
        open: isOpen,
        onOpenChange: setIsOpen,
        trigger: /*#__PURE__*/ _jsx("button", {
            type: "button",
            "data-testid": UPSELL_FLASH_ICON_BUTTON,
            className: "flex items-center justify-center",
            onClick: ()=>setIsOpen(!isOpen),
            children: /*#__PURE__*/ _jsx(FlashFilledIcon, {
                className: "size-3.5 cursor-pointer text-blue-9 hover:text-blue-10"
            })
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-3 p-2",
            children: [
                /*#__PURE__*/ _jsx(FlashFilledIcon, {
                    className: "size-8 text-blue-9"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-12 text-grey-12",
                    children: [
                        children,
                        " ",
                        /*#__PURE__*/ _jsx("button", {
                            onClick: handleUpgradeClick,
                            className: "cursor-pointer text-grey-12 underline hover:text-grey-11",
                            children: "Click to upgrade."
                        })
                    ]
                })
            ]
        })
    });
});
UpsellFlashIconButton.displayName = "UpsellFlashIconButton";
